import { isConfigured } from "@/lib/supabase"

const ADMIN_PASSWORD = "TR60D@26!!!"

export const authService = {
  async signIn(email: string, password: string): Promise<{ error: { message: string } | null }> {
    if (password === ADMIN_PASSWORD) {
      return { error: null }
    }
    return { error: { message: "Senha incorreta" } }
  },

  async signOut(): Promise<{ error: null }> {
    return { error: null }
  },

  async getSession(): Promise<{ data: { session: { user: { email: string } } | null } }> {
    return { data: { session: null } }
  },
}
